import React from "react";
import clsx from "clsx";
import { isSender } from "../../../../utils/chat.utils";
const Text = (props) => {
    const { message } = props;
    const Text = () => {
        const textArray = message.text.split('\n');
        const lastMessageIndex = textArray.length - 1;
        return textArray.map((text, index) => {
            return (React.createElement(React.Fragment, null,
                text,
                index < lastMessageIndex ? React.createElement("br", null) : React.createElement(React.Fragment, null)));
        });
    };
    return (React.createElement("div", { className: clsx('customMessageShadow', 'p-5 ', `${!isSender(message) ? 'bg-white text__msg-box-sender ' : ' customOpensooqBgColor text__msg-box-receive'}`, 'text-dark  mw-lg-400px', `text-${message.sender_id !== message.oid ? 'start' : 'end'}`), "data-kt-element": 'message-text' },
        React.createElement(Text, null)));
};
export default Text;
